import axios from "axios";
import Swal from "sweetalert2";
// Verificar se está em localhost
const hostname = window.location.hostname;

let baseURL;

if(hostname.startsWith("192.168.")){
  baseURL = `http://${hostname}/conecta-painel-api/api/`;
} else if (hostname === "localhost" || hostname === "127.0.0.1") {
  baseURL = "http://localhost:2000/";
} else if (hostname === "www.painel-dev.conectavenda.com.br") {
  baseURL = "https://painel-api-dev.conectavenda.com.br/";
} else if (hostname === "bs-local.com") {
  baseURL =  "http://bs-local.com/conecta-painel-api/api/";
} else {
  baseURL = "https://painel-api.conectavenda.com.br/";
}

// Ambientes não-produtivos (dev/localhost). Espelha a whitelist do baseURL
// acima: tudo que não está listado é tratado como PRODUÇÃO (fail-safe).
// Usado para habilitar a remoção de fundo da logo apenas fora de produção.
const isDevOrLocal =
  hostname.startsWith("192.168.") ||
  hostname === "localhost" ||
  hostname === "127.0.0.1" ||
  hostname === "www.painel-dev.conectavenda.com.br" ||
  hostname === "bs-local.com";

const api = axios.create({
  baseURL: baseURL,
  withCredentials: hostname === "localhost" || hostname === "bs-local.com" ? false : true,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  function (config) {
    config.headers["conecta-session"] = localStorage.getItem("conecta-session") || "";
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  function (response) {
    if (response.headers["conecta-session"]) {
      localStorage.setItem("conecta-session", response.headers["conecta-session"]);
    }
    return response;
  },
  function (error) {
    if(error.response) {
      if (
        (error.response.data.error === "ACAO_NAO_PERMITIDA" ||
          error.response.data.error === "SESSION_EXPIRADA") &&
        (window.location.pathname !== "/login" && window.location.pathname !== "/" && !Boolean(localStorage.getItem("caiu_sessao")))
      ) {
        localStorage.setItem("caiu_sessao", "true");
      }
      // Revendedor do dropshipping: produto, categoria, variação e tabela vêm da mãe
      if (error.response.data?.error === "PRODUTOS_BLOQUEADOS_DROPSHIPPING") {
        Swal.fire({
          title: "Alteração não permitida",
          text: "Recurso indisponível em conta com Dropshipping ativo",
          icon: "warning",
        });
      }
      if (error.response.data?.error === "TABELA_BLOQUEADA_DROPSHIPPING") {
        Swal.fire({
          title: "Alteração não permitida",
          text: "A tabela de preço que veio do fornecedor não pode ser alterada",
          icon: "warning",
        });
      }
      if (error.response.data?.error === "PEDIDO_DROPSHIPPING_NAO_EDITAVEL") {
        Swal.fire({
          title: "Alteração não permitida",
          text: "Recurso indisponível em conta com Dropshipping ativo",
          icon: "warning",
        });
      }
    }
    return Promise.reject(error);
  },
);

export { api, baseURL, hostname, isDevOrLocal };

